type AnalyticsValue = string | number | boolean | null | undefined
type AnalyticsProperties = Record<string, AnalyticsValue>

declare global {
  interface Window {
    dataLayer?: Array<Record<string, unknown>>
    gtag?: (command: 'event', eventName: string, parameters?: Record<string, unknown>) => void
    plausible?: (eventName: string, options?: { props?: Record<string, unknown> }) => void
    posthog?: {
      capture?: (eventName: string, properties?: Record<string, unknown>) => void
    }
  }
}

const cleanProperties = (properties: AnalyticsProperties = {}) => {
  const cleaned: Record<string, unknown> = {}

  for (const [key, value] of Object.entries(properties)) {
    if (value !== undefined) cleaned[key] = value
  }

  return cleaned
}

export function trackEvent(eventName: string, properties: AnalyticsProperties = {}) {
  if (typeof window === 'undefined') return

  const payload = {
    ...cleanProperties(properties),
    path: window.location.pathname,
  }

  window.dataLayer?.push({ event: eventName, ...payload })
  window.gtag?.('event', eventName, payload)
  window.plausible?.(eventName, { props: payload })
  window.posthog?.capture?.(eventName, payload)

  if (import.meta.env.DEV) {
    console.debug('[analytics]', eventName, payload)
  }
}

export function trackPageView(page: string) {
  trackEvent('page_view', { page })
}
